import { Controller } from 'stimulus'
import { isPostHogAvailable } from "src/javascripts/posthog-utils.js"

export default class extends Controller {
  static targets = ['analyticsConsent', 'marketingConsent', 'banner']
  static values = { countryLocale: String }

  connect() {
    if (!this._readConsent()) {
      setTimeout(() => {
        this.bannerTarget?.classList.remove('hidden')
      }, 500)
    } else {
      this.updateGoogleConsent()
    }
  }

  updateGoogleConsent() {
    const consent = this._readConsent() || { analytics: false, marketing: false }

    try {
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': consent.marketing ? 'granted' : 'denied',
          'analytics_storage': consent.analytics ? 'granted' : 'denied',
          'ad_user_data': consent.marketing ? 'granted' : 'denied',
          'ad_personalization': consent.marketing ? 'granted' : 'denied'
        })
      }
      if (window.dataLayer) window.dataLayer.push({ event: 'consent_update', consent })
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.warn('Consent apply failed', e)
    }
  }

  accept() {
    const analytics = this.hasAnalyticsConsentTarget ? this.analyticsConsentTarget.checked : true
    const marketing = this.hasMarketingConsentTarget ? this.marketingConsentTarget.checked : true
    const consent = { analytics, marketing }

    this._setCookie(consent)
    this.updateGoogleConsent()

    try {
      if (isPostHogAvailable() && typeof posthog !== 'undefined') {
        posthog.opt_in_capturing?.()
        posthog.capture?.('user_opted_in', {
          $set: { consent_given: true, opt_in_date: new Date().toISOString(), country_locale: this.countryLocaleValue }
        })
        posthog.people?.set?.({ country_locale: this.countryLocaleValue })
      }
    } catch (e) { console.warn('PostHog opt-in failed', e) }

    try {
      if (typeof mixpanel !== 'undefined' && typeof mixpanel.opt_in_tracking === 'function') mixpanel.opt_in_tracking()
    } catch (e) { console.warn('Mixpanel opt-in failed', e) }

    this._closeBanner()
    location.reload()
  }

  decline() {
    const consent = { analytics: false, marketing: false }
    this._setCookie(consent)
    this.updateGoogleConsent()

    try { if (typeof mixpanel !== 'undefined' && typeof mixpanel.opt_out_tracking === 'function') mixpanel.opt_out_tracking() } catch (e) { console.error(e) }
    try { if (typeof posthog !== 'undefined' && typeof posthog.opt_out_capturing === 'function') posthog.opt_out_capturing() } catch (e) { console.error(e) }

    this._closeBanner()
    location.reload()
  }

  close() { this._closeBanner() }

  // helpers
  _setCookie(consent) {
    const v = encodeURIComponent(JSON.stringify(consent))
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()
    document.cookie = `site_consent=${v}; expires=${expires}; path=/; SameSite=Lax`
  }

  _readConsent() {
    const m = document.cookie.match(/(?:^|; )site_consent=([^;]+)/)
    if (!m) return null
    try { return JSON.parse(decodeURIComponent(m[1])) } catch { return null }
  }

  _closeBanner() { this.bannerTarget?.classList.add('hidden') }
}
